
import Vue from "vue";
import action from "@/components/ActionBarCom.vue";
import pageCom from "@/components/PageCom.vue";
import DeviceRequestBill from "@/assets/js/Bill/DeviceRequestBill";
import dialogCom from "@/components/ModelCom.vue";
import AddrCom from "@/components/AddrCom.vue";
import HttpUtil from "@/assets/js/HttpUtil";
import Urls from "@/assets/js/Urls";
import { StoreTypes } from "@/assets/js/Types";
import delCom from "@/components/DelDataCom.vue";
import Utils from "@/assets/js/Utils";
import { RouterLink } from "vue-router";
import { util } from "vue/types/umd";
export default Vue.extend({
  components: { action, pageCom, dialogCom, AddrCom, delCom, RouterLink },
  data() {
    return {
      delUrl: Urls.DelVideoDevice,
      total: 0,
      pageSize: 20,
      items: [] as any,
      currentPage: 1,
      current: null as any,
      currentSid: null as any,
      title: "",
      form: {
        sid: "" as any,
        deviceName: "",
        addr: "",
        lat: 0,
        lng: 0,
        deviceTypeSid: "",
        groupSid: null as any,
        serial: "",
      },
      deviceTypes: [] as any,
      fileTitle: "",
      noexcel: false,
      choosedItem: [] as any[],
      urlData: {} as any,
      csid: null as any,
    };
  },
  mounted() {
    this.csid = Utils.getCurrentSid(this.$route.path);
    this.deviceTypes = this.$store.state.device[StoreTypes.XC_DEVICE_TYPE].filter(
      (x: any) => x.categorySid == this.csid
    );
    this.urlData = Utils.getActionUrl(this.$route.path);
    this.delUrl = this.urlData.delUrl;
    this.getList();
  },
  methods: {
    handleSelectionChange(val: any) {
      this.choosedItem = [];
      val.forEach((x: any) => {
        this.choosedItem.push(x.sid);
      });
    },
    currentChange(val: any) {
      this.current = val;
    },
    closeDialog() {
      const dialog: any = this.$refs.dialog;
      dialog.hiden();
    },
    opened() {
      setTimeout(() => {
        const addr: any = this.$refs.addr;
        if (!this.current) {
          addr.init(null);
        } else {
          addr.init({
            addr: this.current.addr,
            lat: this.current.lat,
            lng: this.current.lng,
          });
        }
      }, 2000);
    },
    importData() {
      this.fileTitle = "请选择上传摄像头Excel文件";
      this.noexcel = false;
      const upload: any = this.$refs.uploadFile;
      upload.open();
    },
    insert() {
      this.title = "新增设备";
      this.form.sid = null;
      const dialog: any = this.$refs.dialog;
      dialog.show();
    },
    async modify() {
      if (!this.current) {
        throw "请选择一条数据";
      }
      this.form = this.current;
      this.title = "修改控制器";
      const dialog: any = this.$refs.dialog;
      dialog.show();
    },
    async getList() {
      const actionBar: any = this.$refs.action;
      const content = actionBar.getSearch();
      const ret = await DeviceRequestBill.GetNormalDevice(
        content,
        this.currentPage,
        this.pageSize,
        this.urlData.getListUrl
      );
      this.items = ret.data;
      this.total = ret.total;
    },
    async onSubmit() {
      const addr: any = this.$refs.addr;
      const data: any = addr.getData();
      this.form.addr = data.addr;
      this.form.lat = data.lat;
      this.form.lng = data.lng;
      if (!this.form.sid) {
        await HttpUtil.XCHttpPost(this.urlData.addUrl, this.form, true, false);
      } else {
        await HttpUtil.XCHttpPost(this.urlData.updateUrl, this.form, true, false);
      }
      this.closeDialog();
      this.getList();
    },
    del() {
      const dialog: any = this.$refs.del;
      if (this.choosedItem && this.choosedItem.length == 0) {
        if (!this.current) {
          throw "请选择一条数据";
        }
        this.currentSid = this.current.sid;
        dialog.show();
      } else {
        dialog.show(true);
      }
    },
    async temp() {
      const url = `${Utils.GetBaseUrl()}/templates/VideoTemplte.xlsx`;
      window.open(url);
    },
    async batchdel() {
      await HttpUtil.XCHttpPost(Urls.DelVideoDevices, this.choosedItem, true, false);
      this.getList();
    },
    async AsyncVideoDevice() {
      await HttpUtil.XCHttpPost(Urls.AsyncVideoDevice, "", true, false);
      window.setTimeout(() => {
        this.getList();
      }, 2000);
    },
    change(val: number, size: number) {
      this.currentPage = val;
      this.pageSize = size;
      this.getList();
    },
  },
});
